import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import { Typography } from '@mui/material';

export default function SimpleBackdrop({text}: {text?: string}) {
  return (
    <div>
      <Backdrop
        sx={{ flexDirection: 'column', color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={true}
      >
        <CircularProgress color="inherit" />
        <br />
        <Typography>{text}</Typography>
      </Backdrop>
    </div>
  );
}